module.exports = __webpack_public_path__ + "img/home-pencil-orange.209120f8.svg";